import { useContext } from 'react';

import type { CheckBoxEventValue } from '@interstate/components/CheckBox';
import { CheckBox } from '@interstate/components/CheckBox';
import type { InterstateOnChangeCallback } from '@interstate/components/InterstateEvents';
import type { FormCheckBoxProps } from '../types';
import { FormContext } from './formContext';
import { dealLockHooks } from '../../hooks';

export const FormCheckBox = ({ name, label, sx }: FormCheckBoxProps) => {
    const { form, changeHandler } = useContext(FormContext);
    const isLocked = dealLockHooks.useIsDealLocked();

    const checked = form.values[name] as boolean;
    const onChange: InterstateOnChangeCallback<CheckBoxEventValue> = (event) => {
        const isChecked = event.target.value.checked;
        changeHandler(name, isChecked);
    };

    return (
        <CheckBox
            data-testid={'vehicle-input-' + name}
            id={name}
            name={name}
            label={label}
            checked={checked}
            value=""
            onChange={onChange}
            sx={sx}
            disabled={isLocked}
        />
    );
};
